export interface ListPage {
    totalCount: number | null,
    pageSize: number | null,
    pageIndex: number | null
}

export interface Pagination {
    pageSize: number | null,
    pageIndex: number | null
}

export interface FilterOption {
    name: string;
    value?: string | null;
}

export enum SavingStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Successful = "Successful",
    Failure = "Failure"
}